import { Box, Typography } from '@mui/material'
import StarBullet from './StarBullet'

export default function BulletListSection({ title, items, sx = {} }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '520px 1fr' },
        gap: { xs: 2, md: 6 },
        mb: { xs: 6, md: 10 },
        ...sx,
      }}
    >
      <Typography component="h3" sx={{ fontSize: { xs: 22, md: 28 } }}>
        {title}
      </Typography>
      <Box>
        {items.map((item) => (
          <Box key={item} sx={{ display: 'flex', gap: 2, mb: 1.5, alignItems: 'center' }}>
            <StarBullet />
            <Typography sx={{ fontSize: { xs: 18, md: 22 }, lineHeight: 1.5 }}>
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
